import { Aspect } from '@teambit/harmony';

export const CheckoutAspect = Aspect.create({
  id: 'teambit.component/checkout',
});
